// Library ↔ line cost-basis comparison. Margins are per-job decisions and are never compared.
const COST_FIELDS = [
  { item: "material_cost", part: "part_cost", label: "Cost", money: true, modes: ["standard"] },
  { item: "labor_hours", part: "labor_hours", label: "Hrs/unit", modes: ["standard", "flat_rate"] },
  { item: "labor_cost", part: "labor_cost", label: "Labor $/hr", money: true, modes: ["standard", "flat_rate"] },
  { item: "freight", part: "freight", label: "Freight", money: true, modes: ["standard", "flat_rate", "subcontract"] },
  { item: "flat_rate", part: "flat_rate", label: "Price", money: true, modes: ["flat_rate", "subcontract"] },
  { item: "subcontract_cost", part: "subcontract_cost", label: "Sub cost", money: true, modes: ["subcontract"] },
];
const fieldsFor = (item) => { const m = item.pricing_mode || "standard"; return COST_FIELDS.filter((f) => f.modes.includes(m)); };

// Only proposals that are not yet decided carry the Review tag.
export const REVIEWABLE_STATUSES = new Set(["draft", "bid_submitted"]);

const num = (v) => Math.round((parseFloat(v) || 0) * 100) / 100;

export const libSnapshot = (part) =>
  Object.fromEntries([["part_id", part.id], ...COST_FIELDS.map((f) => [f.part, num(part[f.part])])]);

export const findLibraryPart = (item, parts) => {
  // Window Care lines are generated by the estimator panel — the library never re-prices them.
  if (!item || item.wc_key || !parts?.length) return null;
  if (item.lib_ref?.part_id) {
    const p = parts.find((x) => x.id === item.lib_ref.part_id);
    if (p) return p;
  }
  if (item.part_number) {
    const p = parts.find((x) => x.part_number && x.part_number === item.part_number);
    if (p) return p;
  }
  if (item.name) {
    const n = item.name.toLowerCase();
    return parts.find((x) => x.name?.toLowerCase() === n) || null;
  }
  return null;
};

// Legacy lines (no lib_ref) use their own cost fields as the baseline.
export const libraryChanges = (item, part) => {
  if (!part || item.wc_key) return [];
  const fields = fieldsFor(item);
  const base = item.lib_ref || Object.fromEntries(fields.map((f) => [f.part, num(item[f.item])]));
  return fields
    .filter((f) => num(base[f.part]) !== num(part[f.part]))
    .map((f) => ({ key: f.item, label: f.label, from: num(base[f.part]), to: num(part[f.part]), money: !!f.money }));
};

export const applyLibraryValues = (item, part) => ({
  ...item,
  ...Object.fromEntries(fieldsFor(item).map((f) => [f.item, num(part[f.part])])),
  lib_ref: libSnapshot(part),
});

export const acceptLibraryBaseline = (item, part) => ({ ...item, lib_ref: libSnapshot(part) });
